module.exports = "/images/zoo.svg?cd3635b63caffd270595f610c87a633e";